export default function RestaurantWeeksSpringScan(){
    return(
        <img src='scan-restaurant-weeks-spring.jpg' style={{maxWidth:'100%'}} />
    )
}